import { useEffect }            from 'react';
import { store }                from 'index';
import { idleTimeTopLimit }     from './session_limits'
import { 
    LOG_OUT_SAGA, 
    SET_IDLE_TIME,
}                               from 'actions';
import { objType }              from 'types';


export const useHandleInactivity = (idleTimeState: objType) => {

    // count idletime

    useEffect(() => {

        const { idleTime } = idleTimeState;

        if ( idleTime >= idleTimeTopLimit ) {
            return
        }

        const count = setInterval(() => {

          store.dispatch(SET_IDLE_TIME(idleTime + 1));

        }, 1000); 
    
        return () => {
          clearInterval(count);
        };

    }, [idleTimeState]);


    // restart idleTime every user triggered event

    useEffect(() => {

        const eventTriggered = (e: any) => {
            const currentIdleTime = store.getState().session?.idleTime ?? 0;
            if (currentIdleTime < idleTimeTopLimit) {
                store.dispatch(SET_IDLE_TIME(0));
            }
        };
        document.addEventListener('keydown', eventTriggered);
        document.addEventListener('mousemove', eventTriggered);
        document.addEventListener('mousedown', eventTriggered);
        return () => {
            document.removeEventListener('keydown', eventTriggered);
            document.removeEventListener('mousemove', eventTriggered);
            document.removeEventListener('mousedown', eventTriggered);
        };
    }, []);


    // log user out after idle time limit reached
    // DISABLED: Users should never be kicked out
    // useEffect(() => {
    //     
    //     const { idleTime } = idleTimeState;
    //
    //     if ( idleTime >= idleTimeTopLimit) {
    //         store.dispatch(LOG_OUT_SAGA())
    //     }
    //
    // }, [idleTimeState]);

}



